import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { commonmasterService } from "@/api/services/masterService";

interface CommonMaster {
  commonType: string;
  id: string;
  commonName: string;
  commonTypeId: string;
  createdDateTime: string;
  status: number;
}

interface CommonMasterState {
  commonmasterlist: CommonMaster[];
  filteredLists: {
    [key: string]: CommonMaster[];
  };
  loading: boolean;
  error: string | undefined;
}

const initialState: CommonMasterState = {
  commonmasterlist: [],
  filteredLists: {},
  loading: false,
  error: undefined,
};

export const fetchCommonMaster = createAsyncThunk(
  "commonMaster/fetchCommonMaster",
  async (_, { rejectWithValue }) => {
    try {
      const response = await commonmasterService.getallCommonMaster();
      return response.data ? response.data : response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || "Failed to fetch common masters"
      );
    }
  }
);
// Create the slice
const CommonMasterSlice = createSlice({
  name: "commonmaster",
  initialState,
  reducers: {resetcommonmaster:() => initialState,},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommonMaster.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchCommonMaster.fulfilled, (state, action) => {
        state.commonmasterlist = action.payload;
        // Filter lists dynamically by commonType
        const filterTypes = [
          "Product",
          "Risk",
          "Zone",
          "Designation",
          "ID",
          "Gender",
          "Resident Status",
          "Tax Classification",
          "MSME",
          "Service Charge",
          "Service Tax/GST",
          "Payment",
          "Legal Status",
          "Type",
           "Margin Type",
           "Tax",
           "CreditType",
           "Dealer Category",
           "Vendor Type",
           "Client Type",
        "Product Type", 
          "Margin Type",
          "Tax",
          "CreditType",
          "Dealer Category",
          "Vendor Type",
          "Client Type",
          "Source of Fund",
          "Sale Type",
          "Mode",
          "Purpose",
          "Visa Type",
          "Ticket Class","ServiceType","Priority Rating","Product Type","Operation Type","Transaction Type","Flag",
           "Transfer Type",
          "Currency Type",
          "OrderType",
          "EVTM Payment Type",
          "Agent Category",
        ];
        state.filteredLists = filterTypes?.reduce(
          (acc, filterType) => {
            acc[filterType] = action.payload?.filter(
              (item: CommonMaster) => item.commonType === filterType
            );
            return acc;
          },
          {} as { [key: string]: CommonMaster[] }
        );
        state.loading = false;
      })
      .addCase(fetchCommonMaster.rejected, (state, action) => {
        state.loading = false;
        state.error =
          typeof action.payload === "string"
            ? action.payload
            : "Unknown error occurred";
      });
  },
});

// Export the reducer
export default CommonMasterSlice.reducer;
export const { resetcommonmaster } = CommonMasterSlice.actions;
